module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"Title":"Rapport de bugs"}}')
  delete Component.options._Ctor
}
